import { all, call, delay, fork, put, takeLatest } from '@redux-saga/core/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { callNotify } from '../..';
import { nextPage } from "../../util/library/Router";
import { OpService } from "../../util/services/operation";
import { VesselService } from "../../util/services/vessel";
import { OPERATION_TYPE, PATHNAME } from "../../util/varibles/constants";
import { IPosition } from '../../util/varibles/interface';
import { opDetailActions } from "./reducer";

function* getOperationWatcher({ ...args }) {

    yield delay(200);
    const { tenant_id, id } = args.payload;
    yield fork(function* (): Generator<any, void, any> {
        try {
            const operation = yield call(OpService.detail, tenant_id, id);
            const { operation: { sub_operations, operation_type }, vessel, vessel: { iot_name } } = operation;
            if (operation_type !== OPERATION_TYPE.EVENT && operation_type !== OPERATION_TYPE.SUPPORT) {
                const total = sub_operations.reduce((total: any, item: any) => {
                    total.totalWeight += item.total_weight;
                    total.totalAmount += item.fish_amount;
                    return total;
                }, { totalWeight: 0, totalAmount: 0 });
                operation.operation = { ...operation.operation, ...total };
            }
            if (iot_name && iot_name !== '-') {
                const gps: any = yield call(VesselService.getPositions, [iot_name])
                if (gps.length > 0) {
                    const { time, ...args } = gps[0];
                    const [value] = time.split('.');
                    const gpsTime = value[value.length - 1] === 'Z' ? new Date(value.replace(' ', 'T')).getTime() :
                        new Date(value.replace(' ', 'T') + 'Z').getTime();

                    operation.vessel = { ...vessel, gps: { ...args, time: gpsTime } }
                }
            }
            yield put(opDetailActions.getOpSuccess(operation));
        } catch (error: any) {
            yield put(opDetailActions.getOpFailure())
            if (error.response && error.response.status === 445) {
                nextPage(PATHNAME.HOME);
                callNotify?.error({
                    title: 'Error',
                    description: 'Operation not found',
                })
            }
        }
    })
    yield fork(function* (): Generator<any, void, any> {
        yield put(opDetailActions.getActualRoute({ tenant_id, id }))
    })

}

function* getActualRouteWatcher(action: PayloadAction<{ id: string, tenant_id: string }>): Generator<any, void, any> {
    try {
        const { tenant_id, id } = action.payload;
        const result = yield call(OpService.actualRoute, { id, tenant_id });
        const actualRoute = {
            ...result,
            real_route: {
                ...result.real_route,
                points: result.real_route?.points?.map((item: (IPosition & { time: string })) => {
                    return {
                        ...item,
                        time: new Date(item.time.replace(" ", "T") + "Z").getTime(),
                    }
                }) ?? [],
            },
        };

        yield put(opDetailActions.updateState({ actualRoute, loadingRoute: false }));
    } catch (error) {
        yield put(opDetailActions.updateState({ loadingRoute: false }));
    }
}

export default function* operationDetailSaga() {
    yield all([
        takeLatest(opDetailActions.getOpRequest.type, getOperationWatcher),
        takeLatest(opDetailActions.getActualRoute.type, getActualRouteWatcher)
    ])
}
